// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EKbIb","panel":"styles_panel__MyaDf","h2Title":"styles_h2Title__7I7Mq","h1Title":"styles_h1Title__ORamB"};